// src/components/LanguageSwitcher.js
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { AuthContext } from './Provider';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { user, updateLanguagePreference } = useContext(AuthContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    // Change language in i18next
    i18n.changeLanguage(lng);
    
    // Save to localStorage for non-logged in users
    localStorage.setItem('preferredLanguage', lng);
    
    // If user is logged in, save preference to profile
    if (user && updateLanguagePreference) {
      updateLanguagePreference(lng)
        .catch(error => console.error('Failed to save language preference:', error));
    }
    
    // Close dropdown after selection
    setIsDropdownOpen(false);
  };

  // Toggle dropdown visibility
  const toggleDropdown = () => setIsDropdownOpen(prev => !prev);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  // On first render, check localStorage for preferred language
  useEffect(() => {
    const storedLanguage = localStorage.getItem('preferredLanguage');
    
    if (storedLanguage && i18n.language !== storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, []);

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button 
        className="dropdown-toggle" 
        onClick={toggleDropdown}
        aria-expanded={isDropdownOpen}
        aria-label="Language selector"
        title="Change language"
      >
        {/* Removed icon as requested */}
        <span className="current-language">{i18n.language.toUpperCase()}</span>
      </button>
      
      {isDropdownOpen && (
        <div className="dropdown-menu">
          <label className="dropdown-item">
            <input
              type="radio"
              name="language"
              value="en"
              checked={i18n.language === 'en'}
              onChange={() => changeLanguage('en')}
            />
            <span>English</span>
          </label>
          <label className="dropdown-item">
            <input
              type="radio"
              name="language"
              value="lv"
              checked={i18n.language === 'lv'}
              onChange={() => changeLanguage('lv')}
            />
            <span>Latviešu</span>
          </label>
          <label className="dropdown-item">
            <input
              type="radio"
              name="language"
              value="ru"
              checked={i18n.language === 'ru'}
              onChange={() => changeLanguage('ru')}
            />
            <span>Русский</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;